import './Main.scss';

import 'DistributionPackages/GesagtGetan.Basic/Resources/Private/Assets/Variables/createNamespace';
import { domReady } from 'DistributionPackages/GesagtGetan.Basic/Resources/Private/Assets/Helper';

import '../Fusion/Component/Header';
import '../Fusion/Component/Hamburger';
import '../Fusion/News/Entry';
import '../Fusion/Content/Form';
import '../Fusion/Content/Popup/Popup.js';

domReady(function () {
    _gg.onReadyRun();
});
